import { Long, UserRankLevelDTO } from '../api';
import heitie from '../assets/rank-levels/level-1-heitie.svg';
import qingtong from '../assets/rank-levels/level-2-qingtong.svg';
import baiyin from '../assets/rank-levels/level-3-baiyin.svg';
import huangjin from '../assets/rank-levels/level-4-huangjin.svg';
import bojin from '../assets/rank-levels/level-5-bojin.svg';
import zuanshi from '../assets/rank-levels/level-6-zuanshi.svg';
import dashi from '../assets/rank-levels/level-7-dashi.svg';
import wangzhe from '../assets/rank-levels/level-8-wangzhe.svg';

export interface RankLevelDef {
  /** 段位序号 1-8 */
  level: number;
  /** 段位名称（固定） */
  name: string;
  /** 勋章图片 */
  icon: string;
}

/** 段位等级固定，只有阈值金额可在公司配置中调整 */
export const RANK_LEVELS: RankLevelDef[] = [
  { level: 1, name: '黑铁', icon: heitie },
  { level: 2, name: '青铜', icon: qingtong },
  { level: 3, name: '白银', icon: baiyin },
  { level: 4, name: '黄金', icon: huangjin },
  { level: 5, name: '铂金', icon: bojin },
  { level: 6, name: '钻石', icon: zuanshi },
  { level: 7, name: '超凡大师', icon: dashi },
  { level: 8, name: '最强王者', icon: wangzhe },
];

/**
 * 默认段位阈值（单位：万），与后端 RankLevelServiceImpl.DEFAULT_LEVELS 保持一致。
 * 依次为青铜/白银/黄金/铂金/钻石/超凡大师/最强王者的业绩下限。
 */
export const DEFAULT_ANNUAL_LEVELS = [30, 60, 90, 120, 150, 180, 240];

/**
 * 校验公司配置的阈值：必须为长度 7、严格递增的正数，否则回退默认值。
 * 与后端 RankLevelServiceImpl.resolveThresholds 逻辑一致。
 */
export const resolveAnnualLevels = (config?: (Long | number)[]): number[] => {
  if (!config || config.length !== DEFAULT_ANNUAL_LEVELS.length) {
    return DEFAULT_ANNUAL_LEVELS;
  }
  const values = config.map((item) => Number(item));
  let prev = 0;
  for (const value of values) {
    if (!Number.isFinite(value) || value <= prev) {
      return DEFAULT_ANNUAL_LEVELS;
    }
    prev = value;
  }
  return values;
};

/**
 * 无放款记录用户的段位兜底（黑铁）。
 * 后端 user_levels 接口不返回无年度业绩的用户，前端按此兜底展示。
 */
export const defaultUserRankLevel = (
  config?: (Long | number)[],
): UserRankLevelDTO => {
  const thresholds = resolveAnnualLevels(config);
  return {
    annualBrokerage: 0,
    level: 1,
    levelName: RANK_LEVELS[0].name,
    nextLevelName: RANK_LEVELS[1].name,
    nextLevelThreshold: thresholds[0],
    gapBrokerage: thresholds[0] * 10000,
  };
};

/**
 * 按年度业绩（单位：元）计算段位
 */
export const computeAnnualLevel = (
  brokerageYuan: number,
  config?: (Long | number)[],
): RankLevelDef => {
  const thresholds = resolveAnnualLevels(config);
  let level = 1;
  for (const threshold of thresholds) {
    if (brokerageYuan >= threshold * 10000) {
      level++;
    }
  }
  return RANK_LEVELS[level - 1];
};
